import { percentageRatio } from '@/utilities/Helpers';

export interface EntryWithTime {
	id: string;
	name: string;
	timeIntervalInMs: number;
}

export const getSpentTimeRatio = (item: EntryWithTime, otherItem: EntryWithTime) => percentageRatio(item.timeIntervalInMs, otherItem.timeIntervalInMs);
